import {
  IJobListFilters,
  JobListFiltersKeys,
  JobListViews,
} from '@th-types/jobs.type';

export function updateJobListSearchParams(
  searchParams: URLSearchParams,
  jobListFilters: IJobListFilters
) {
  searchParams.set(JobListFiltersKeys.SEARCH_TEXT, jobListFilters.searchFilter);
  searchParams.set(
    JobListFiltersKeys.DATE_FROM,
    jobListFilters?.dateRange?.startDate?.toDateString() || ''
  );
  searchParams.set(
    JobListFiltersKeys.DATE_TO,
    jobListFilters?.dateRange?.endDate?.toDateString() || ''
  );
  searchParams.set(
    JobListFiltersKeys.SEARCH_TYPE,
    jobListFilters.jobSearchType
  );
  searchParams.set(JobListFiltersKeys.IS_ACTIVE, jobListFilters.period);
  searchParams.set(JobListFiltersKeys.SCOPE, jobListFilters.scope);
  searchParams.set(
    JobListFiltersKeys.HIDDEN_JOBS,
    jobListFilters.hiddenJobs?.toString() || 'false'
  );

  if (jobListFilters.viewType === JobListViews.SHIFTS) {
    searchParams.set(
      JobListFiltersKeys.ONBOARDING,
      jobListFilters.onboarding?.toString() || 'false'
    );
    searchParams.set(
      JobListFiltersKeys.OPEN_SHIFTS,
      jobListFilters.openShifts?.toString() || 'false'
    );
    searchParams.set(
      JobListFiltersKeys.MISSING_HOURS,
      jobListFilters.missingHours?.toString() || 'false'
    );
    searchParams.set(
      JobListFiltersKeys.NO_CHECK_IN_OUT,
      jobListFilters.noCheckInOut?.toString() || 'false'
    );
    searchParams.set(
      JobListFiltersKeys.TO_APPROVE,
      jobListFilters.toApprove?.toString() || 'false'
    );
    searchParams.set(
      JobListFiltersKeys.UPCOMING,
      jobListFilters.toApprove?.toString() || 'false'
    );
    searchParams.set(
      JobListFiltersKeys.MARK_PAID,
      jobListFilters.markPaid?.toString() || 'false'
    );
  }
  return searchParams;
}
